/*
  Helper method for determining is outcome suspended
*/
export function isOutcomeSuspended (outcome) {
  // Currenty detecting suspended status
  return (
    (outcome.marketStatus === 'SUSPENDED') ||
    outcome.marketSuspended
  )
}

/*
  Helper method for determining is outcome visible

  @return {Boolean} isVisible
*/
export function isOutcomeVisible (outcome) {
  return (
    (outcome.outcomeStatus === 'UNSPECIFIED') &&
    (outcome.marketStatus === 'ACTIVE' || outcome.marketStatus === 'SUSPENDED') &&
    outcome.marketVisible
  )
}

export function getOutcomeParam (outcome) {
  try {
    const param = Number.parseFloat(outcome.specifiers)

    return param
  } catch (err) {
    return 0
  }
}

const DEFAULT_OUTCOME_POSITION = 2

const outcomeSortingFunctionsMap = {
  DEFAULT: (a, b) => {
    return (a.orderPosition || DEFAULT_OUTCOME_POSITION) - (b.orderPosition || DEFAULT_OUTCOME_POSITION)
  },

  /*
    Table sorting type used when we need expand odds grid
  */
  TABLE: (a, b) => {
    // Multiplying outcome parameter by 100 to remove floats
    const paramA = Number.parseFloat(getOutcomeParam(a))
    const paramB = Number.parseFloat(getOutcomeParam(b))

    const directionA = (paramA < 0) ? -1 : 1
    const directionB = (paramB < 0) ? -1 : 1

    const paramAWeight = paramA * 100
    const paramBWeight = paramB * 100

    // Defining outcomes order position
    const positionA = (a.orderPosition || DEFAULT_OUTCOME_POSITION)
    const positionB = (b.orderPosition || DEFAULT_OUTCOME_POSITION)

    return (directionA * (paramAWeight + positionA)) - (directionB * (paramBWeight + positionB))
  }
}

export function getOutcomeSortingFunction (sortingType = 'DEFAULT') {
  return outcomeSortingFunctionsMap[sortingType]
}
